import type { AffineThemeKeyV2, AffineThemeV2 } from './v2/light';

/**
 * Colour names stored in documents and rows: note backgrounds and shadows,
 * tag colours. They stay CSS variables; each carries the value of its role.
 */
export const PERSISTED_COLOUR_ROLES = {
  noteBackgroundBlack: 'edgeless/note/black',
  noteBackgroundBlue: 'edgeless/note/blue',
  noteBackgroundGreen: 'edgeless/note/green',
  noteBackgroundGrey: 'edgeless/note/grey',
  noteBackgroundMagenta: 'edgeless/note/magenta',
  noteBackgroundOrange: 'edgeless/note/orange',
  noteBackgroundPurple: 'edgeless/note/purple',
  noteBackgroundRed: 'edgeless/note/red',
  noteBackgroundTeal: 'edgeless/note/teal',
  noteBackgroundWhite: 'edgeless/note/white',
  noteBackgroundYellow: 'edgeless/note/yellow',
  noteShadowBox: 'shadow/note/box',
  noteShadowFilm: 'shadow/note/film',
  noteShadowFloat: 'shadow/note/float',
  noteShadowPaper: 'shadow/note/paper',
  noteShadowSticker: 'shadow/note/sticker',
  tagBlue: 'chip/label/blue',
  tagGray: 'chip/label/grey',
  tagGreen: 'chip/label/green',
  tagOrange: 'chip/label/orange',
  tagPink: 'chip/label/magenta',
  tagPurple: 'chip/label/purple',
  tagRed: 'chip/label/red',
  tagTeal: 'chip/label/teal',
  tagWhite: 'chip/label/white',
  tagYellow: 'chip/label/yellow',
} as const satisfies Record<string, AffineThemeKeyV2>;

export type PersistedColourName = keyof typeof PERSISTED_COLOUR_ROLES;

/** The stored colour names of one theme, read from its table. */
export function persistedColours(
  table: AffineThemeV2
): Record<PersistedColourName, string> {
  return Object.fromEntries(
    Object.entries(PERSISTED_COLOUR_ROLES).map(([name, role]) => [
      name,
      table[role],
    ])
  ) as Record<PersistedColourName, string>;
}
